import script from "./AiAssistant.vue?vue&type=script&setup=true&lang=js"
export * from "./AiAssistant.vue?vue&type=script&setup=true&lang=js"

import "./AiAssistant.vue?vue&type=style&index=0&id=3cb494e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cb494e2"]])

export default __exports__